/**
 * État d'ouverture de la palette de commandes.
 *
 * Partagé au module, comme `useSidebar` : l'en-tête l'ouvre, la palette se
 * ferme elle-même, et le raccourci clavier vit ailleurs encore. Un `ref` local
 * à chaque appel les laisserait sans lien.
 */
const paletteOpen = ref(false)

export function useCommandPalette() {
  function open() { paletteOpen.value = true }
  function close() { paletteOpen.value = false }
  function toggle() { paletteOpen.value = !paletteOpen.value }

  return { paletteOpen, open, close, toggle }
}
